import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1420px;
	margin: 0 auto;
	color: ${CSSVars.white};
	text-align: center;
	position: relative;

	p.subtitle {
		color: ${CSSVars.primary500};
		font-weight: 600;
		font-size: ${CSSVars.fontSizeMD};
		text-transform: uppercase;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSizeXL};
		}
	}

	h2 {
		font-weight: 600;
		font-size: ${CSSVars.fontSize4XL};
		margin: 30px 0 50px;
		font-size: ${CSSVars.fontSize2XL};

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize4XL};
		}
	}

	.desc {
		max-width: 1050px;
		color: white;
		margin: 0 auto;
		text-align: left;

		p {
			margin-bottom: 20px;
		}
	}
`;
